import { render, staticRenderFns } from "./RankImage.vue?vue&type=template&id=a973c9aa"
import script from "./RankImage.vue?vue&type=script&lang=js"
export * from "./RankImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports